module.exports = __webpack_public_path__ + "static/img/3805_phase_function_Paper_PointsHejduk_Prediction.401a256.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3805_phase_function_Paper_PointsHejduk_Prediction.png
// module id = obO2
// module chunks = 0